import React from "react";

import type { ContentComponentProps, FinderFooterContent } from "@/content-V2/types";

import { DesktopFooter } from "./FinderFooter/DesktopFooter";
import { MobileFooter } from "./FinderFooter/MobileFooter";

export const FinderFooter: React.FC<ContentComponentProps<FinderFooterContent>> = (props) => {
  return (
    <>
      <MobileFooter {...props} />
      <DesktopFooter {...props} />
    </>
  );
};
